import { Divider, Form, message } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { agentLogin, register } from "../../../api/auth";
import Laptop2 from "../../../assets/Laptop2.svg";
import LoginLayout from "../../../components/LoginLayout";
import BUTTON from "../../../components/button";
import Checkbox from "../../../components/checkbox";
import { handleAuthRedirect } from "../../../constants/utils";
import InputField from "../../../components/inputField";

const CreatePassword = () => {
  const [remember, setRemember] = useState();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const payload = state.payload;

  const onFinish = async (values) => {
    setLoader(true);
    payload.password = values.password;
    try {
      const res = await register(payload);
      if (res) {
        message.success("Registered Successfully");
        const LoginRes = await agentLogin({
          email: payload?.email,
          password: payload?.password,
        });
        localStorage.setItem("otpToken", LoginRes?.otp_token);
        localStorage.setItem("Login", "Agent");
        navigate("/agent/otp");
      }
    } catch (error) {
      message.error(error?.message);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    const AdminLogin = localStorage.getItem("Login");
    const Token = localStorage.getItem("accessToken");
    if (AdminLogin && Token) {
      handleAuthRedirect(AdminLogin, navigate);
    }
  }, [navigate]);
  return (
    <LoginLayout image={Laptop2} alt="Create Password">
      <div className="min-h-screen flex items-center justify-center">
        <div className="mx-4 sm:mx-6 lg:mx-20 xl:mx-40 w-full max-w-md">
          <div className="space-y-5">
            <p className="text-2xl sm:text-3xl lg:text-4xl font-bold">
              Create Password
            </p>
            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item
                name={"password"}
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your Password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !value ||
                        (value.length >= 6 &&
                          /[A-Z]/.test(value) &&
                          /[a-z]/.test(value) &&
                          /[0-9]/.test(value) &&
                          /[!@#$%^&*]/.test(value))
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "Password must be at least 6 characters and include at least one uppercase letter, one digit, and one special character."
                      );
                    },
                  }),
                ]}
                label={
                  <span className="text-base font-bold font-Almarai">
                    Password
                  </span>
                }
              >
                <InputField
                  placeholder={"Write Password"}
                  name={"password"}
                  type={"password"}
                  inputType={"both"}
                />
              </Form.Item>
              <Form.Item
                name={"repeatPassword"}
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your Password Again!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("The password does not match!")
                      );
                    },
                  }),
                ]}
                label={
                  <span className="text-base font-bold font-Almarai">
                    Confirm Password
                  </span>
                }
              >
                <InputField
                  placeholder={"Confirm Password"}
                  name={"repeatPassword"}
                  type={"password"}
                  inputType={"both"}
                />
              </Form.Item>
              <Form.Item>
                <Checkbox description="Remember Me" onChecked={setRemember} />
              </Form.Item>
              <Form.Item>
                <BUTTON
                  title="Confirm"
                  htmlType="submit"
                  type="primary"
                  loading={loader}
                />
              </Form.Item>
              <div className="px-6">
                <Divider className="bg-[#C7D1D9] border" />
              </div>
              <Form.Item>
                <Link to="/agent/registration">
                  <BUTTON title="Back" type="secondary" />
                </Link>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </LoginLayout>
  );
};
export default CreatePassword;
